// 3.30.0: choose a library category from a list, or type a new one. Owner, 2026-10-27: "the import dxf should allow
// saving imported models into categories". Before 3.30.0 the category was a text box with a hidden suggestion list.
import { useEffect, useState } from "preact/hooks";

const NEW = "__new__";

export function CategoryPicker({ id, value, choices, onChange }: { id: string; value: string; choices: string[]; onChange: (category: string) => void }) {
  const known = choices.includes(value);
  const [typing, setTyping] = useState(!known);
  // a value set from outside that is in the list shows in the list again
  useEffect(() => {
    if (choices.includes(value)) setTyping(false);
  }, [value, choices]);
  return (
    <span class="category-picker">
      <select
        id={id}
        value={typing ? NEW : value}
        onChange={(e) => {
          const v = (e.target as HTMLSelectElement).value;
          if (v === NEW) {
            setTyping(true);
            onChange("");
          } else {
            setTyping(false);
            onChange(v);
          }
        }}
      >
        {choices.map((c) => (
          <option key={c} value={c}>
            {c}
          </option>
        ))}
        <option value={NEW}>New category…</option>
      </select>
      {typing && (
        <input
          id={`${id}-new`}
          value={value}
          placeholder="Name of the new category"
          aria-label="Name of the new category"
          onInput={(e) => onChange((e.target as HTMLInputElement).value)}
          onKeyDown={(e) => e.stopPropagation()}
        />
      )}
    </span>
  );
}
